import { render, staticRenderFns } from "./UiScrollableSlider.vue?vue&type=template&id=1347574e&scoped=true&"
import script from "./UiScrollableSlider.vue?vue&type=script&lang=js&"
export * from "./UiScrollableSlider.vue?vue&type=script&lang=js&"
import style0 from "./UiScrollableSlider.vue?vue&type=style&index=0&id=1347574e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347574e",
  null
  
)

export default component.exports